import getEndpoint from '@/helpers/getEndpoint'
import API from '@/services/API'

async function getGTMDetails(id: number) {
  const endpoint = getEndpoint('CHECKOUT') + id
  const response = await API.get<Success>(endpoint)

  return response
}

type Success = Record<string, any>

export default getGTMDetails
